import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/cabinet')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const ifWhats = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isName === 'tech8') next('/cabinet')
    else {
      next()
      return
    }
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', alias: '/kitchen', name: 'Панель', component: () => import('../components/panel')},
    {path: '/partners', name: 'Регистрация партнера', component: () => import('../components/partners')},
    {path: '/cabinet', name: 'Монитор', component: () => import('../components/dashboard'), beforeEnter: ifAuthenticated},
    {path: '/widgets', name: 'Виджеты', component: () => import('../components/widgets'), beforeEnter: ifWhats},
    {path: '/widget/:id', name: 'widget', component: () => import('../components/widget'), beforeEnter: ifWhats},
    {path: '/clients', name: 'Клиенты', component: () => import('../components/clients'), beforeEnter: ifWhats},
    {path: '/cash', name: 'Публичные', component: () => import('../components/cash'), beforeEnter: ifWhats},
    {path: '/whatsapp/:id', name: 'wclient', component: () => import('../components/whatsapp'), beforeEnter: ifAuthenticated},
    {path: '/whatsapp', name: 'WhatsApp', component: () => import('../components/whatsapps'), beforeEnter: ifAuthenticated},
    {path: '/whatsappl', name: 'WhatsAppl', component: () => import('../components/whatsappsl'), beforeEnter: ifWhats},
    {path: '/client/:id', name: 'client', component: () => import('../components/client'), beforeEnter: ifWhats},
    {path: '/telegram/:id', name: 'TelegramClient', component: () => import('../components/telegram'), beforeEnter: ifAuthenticated},
    {path: '/telegram', name: 'Telegram', component: () => import('../components/telegrams'), beforeEnter: ifAuthenticated},
    {path: '/promo', name: 'Партнеры', component: () => import('../components/promos'), beforeEnter: ifAuthenticated},
    {path: '/login', name: 'Авторизация', component: () => import('../components/auth'), beforeEnter: ifNotAuthenticated},
    {path: '*', name: '404', component: () => import('../components/404')}
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js